import React from 'react';
import { FileTextOutlined } from '@ant-design/icons';
import { Col, Divider, Row, Table, Typography } from 'antd';

import locale from 'antd/es/locale/pt_BR';
import LayoutDashboard from '../../../../layout/LayoutAdmin';
import { Loading } from '../../../../components/Loading';
import { useExtratoCongelamento } from './useExtratoCongelamento';
import CongelamentosModal from './components/CongelamentosModal';
import { convertMoedaBRDoJSComAte3CasasDecimais, convertMoedaBRDoJSComExtamente2CasasDecimais } from '../../../../services/Conversores';
import './style.css'

const { Title, Text } = Typography;

const ExtratoCongelamento: React.FC = () => {

    const {
        isLoading,
        refContagemDoFiltroRecargas,
        refContagemDoFiltroCongelamentos,
        isResponseModalVisible,
        congelamentosModalDate,
        handleCloseCongelamentosModal,
        columnsRecargas,
        columnsCongelamentos,
        extrato,
    } = useExtratoCongelamento();

    return (
        <LayoutDashboard>
            <Loading
                loading={isLoading}
            >
                <Row
                    style={{
                        marginBottom: 16,
                    }}
                >
                    <Col span={24}>
                        <Row
                            justify='space-between'
                        >
                            <Title level={4}>
                                <FileTextOutlined style={{ fontSize: 22, marginRight: 10 }} />
                                {"Extrato congelamentos"}
                            </Title>
                        </Row>

                        <Divider />
                    </Col>
                </Row>

                <Title level={3}>
                    {"Resumo"}
                </Title>

                <Row>
                    <Col
                        span={8}
                        style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Typography.Text>Valor total das recargas</Typography.Text>
                        <Typography.Text
                            strong
                            style={{
                                color: 'green',
                            }}
                        >
                            {`R$ ${convertMoedaBRDoJSComExtamente2CasasDecimais(extrato?.valorTotalEmRecargas)}`}
                        </Typography.Text>
                    </Col>

                    <Col
                        span={8}
                        style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Typography.Text>Custo total dos congelamentos</Typography.Text>
                        <Typography.Text
                            strong
                            style={{
                                color: "#F00"
                            }}
                        >
                            {`R$ ${convertMoedaBRDoJSComAte3CasasDecimais(extrato?.custoTotalEmCongelamentos)}`}
                        </Typography.Text>
                    </Col>

                    <Col
                        span={8}
                        style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Typography.Text>Saldo restante</Typography.Text>
                        <Typography.Text
                            strong
                        >
                            {`R$ ${convertMoedaBRDoJSComAte3CasasDecimais(extrato?.saldoRestante)}`}
                        </Typography.Text>
                    </Col>
                </Row>

                <Divider />

                <Row justify='space-between'>
                    <Col
                        className='extratoTableContainer'
                        span={11}
                    >
                        <Title level={3}>
                            {"Recargas"}
                        </Title>

                        <Table
                            className='marginTopTables'
                            rowKey={(record) => record.id}
                            loading={isLoading}
                            columns={columnsRecargas}
                            dataSource={extrato?.recargas}
                            onChange={
                                (pagination, filters, sorter, extra) => {
                                    refContagemDoFiltroRecargas.current = extra.currentDataSource
                                }
                            }
                            footer={(registros) => {
                                return (
                                    <div
                                        style={{
                                            textAlign: 'end'
                                        }}
                                    >
                                        <Text>
                                            {`Mostrando: ${registros.length} de ${refContagemDoFiltroRecargas.current.length === 0 ?
                                                extrato?.recargas.length :
                                                refContagemDoFiltroRecargas.current.length} num total de ${extrato?.recargas.length} `}
                                        </Text>
                                    </div>
                                )
                            }}
                            size="small"
                            pagination={{
                                locale: { items_per_page: '' },
                                showSizeChanger: true,
                                defaultPageSize: 100,
                                position: ['bottomRight'],
                                pageSizeOptions: ['10', '20', '50', '100']
                            }}
                            locale={locale.Table}
                        />
                    </Col>

                    <Col
                        className='extratoTableContainer'
                        span={12}
                    >
                        <Title level={3}>
                            {"Congelamentos por dia"}
                        </Title>

                        <Table
                            className='marginTopTables'
                            rowKey={(record) => record.data}
                            columns={columnsCongelamentos}
                            dataSource={extrato?.congelamentos}
                            onChange={
                                (pagination, filters, sorter, extra) => {
                                    refContagemDoFiltroCongelamentos.current = extra.currentDataSource
                                }
                            }
                            size="small"
                            pagination={{
                                locale: { items_per_page: '' },
                                showSizeChanger: true,
                                defaultPageSize: 100,
                                position: ['bottomRight'],
                                pageSizeOptions: ['10', '20', '50', '100']
                            }}
                            footer={(registros) => {
                                return (
                                    <div
                                        style={{
                                            textAlign: 'end'
                                        }}
                                    >
                                        <Text>
                                            {`Mostrando: ${registros.length} de ${refContagemDoFiltroCongelamentos.current.length === 0 ?
                                                extrato?.congelamentos.length :
                                                refContagemDoFiltroCongelamentos.current.length} num total de ${extrato?.congelamentos.length} `}
                                        </Text>
                                    </div>
                                )
                            }}
                            locale={locale.Table}
                        />
                    </Col>
                </Row>
            </Loading>

            <CongelamentosModal
                visible={isResponseModalVisible}
                date={congelamentosModalDate}
                onClose={handleCloseCongelamentosModal}
            />
        </LayoutDashboard >
    );
}

export default ExtratoCongelamento;
